import { PaymentStatus } from './../models/request-round/request-record.interface';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundPaymentStatus',
  standalone: true
})
export class RoundPaymentStatusPipe implements PipeTransform {

  transform(value: PaymentStatus | string): string {
    switch (value) {
      case PaymentStatus.TO_PAY:
      case 'TO_PAY':
        return 'Da pagare';
      case PaymentStatus.PENDING:
      case 'PENDING':
        return 'Da validare';
      case PaymentStatus.PAID:
      case 'PAID':
        return 'Pagato';
      case PaymentStatus.CANCELLED:
      case 'CANCELLED':
        return 'Annullato';
      case PaymentStatus.REFUNDED:
      case 'REFUNDED':
        return 'Rimborsato';
      case PaymentStatus.CONTRATTO_APL:
      case 'CONTRATTO_APL':
        return 'Contratto APL';
      default:
        return value;
    }
  }
}

